module.exports = __webpack_public_path__ + "images/cc90a800d52a9b67074cb3acb99d4373.svg";